import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ROUTING_INFORME_PENSIONES } from '@constants/url.constant';
import { InformePensionesHomeComponent } from './pages/informe-pensiones-home/informe-pensiones-home.component';

const routes: Routes = [
  {
    path: "",
    redirectTo: ROUTING_INFORME_PENSIONES.HOME_INFORME_PENSIONES,
    pathMatch: "full",
  },
  {
    path: ROUTING_INFORME_PENSIONES.HOME_INFORME_PENSIONES,
    component: InformePensionesHomeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InformePensionesRoutingModule { }
